// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as NLOrderServicesInfoVm from "./vm-mapper/NLOrderServicesInfoVm.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";

function getViewLabel(services) {
  return {
          hd: {
            label: "Is Helper Required",
            value: {
              TAG: /* Text */0,
              _0: services.is_helper_required
            }
          },
          tl: {
            hd: {
              label: "Interstate Order (Y/N)",
              value: {
                TAG: /* Text */0,
                _0: services.is_interstate_order
              }
            },
            tl: {
              hd: {
                label: "Is Outstation Trip",
                value: {
                  TAG: /* Text */0,
                  _0: services.is_outstation_trip
                }
              },
              tl: {
                hd: {
                  label: "Return Trip(Y/N)",
                  value: {
                    TAG: /* Text */0,
                    _0: services.is_return_trip
                  }
                },
                tl: {
                  hd: {
                    label: "Has Waypoints (True/False)",
                    value: {
                      TAG: /* Text */0,
                      _0: services.has_waypoints
                    }
                  },
                  tl: {
                    hd: {
                      label: "Booked Vehicle Type",
                      value: {
                        TAG: /* Text */0,
                        _0: services.booked_vehicle_type
                      }
                    },
                    tl: {
                      hd: {
                        label: "Is Helper+1 labour",
                        value: {
                          TAG: /* Text */0,
                          _0: services.is_helper_labour_order
                        }
                      },
                      tl: {
                        hd: {
                          label: "Is Rental Order",
                          value: {
                            TAG: /* Text */0,
                            _0: services.is_rental_order
                          }
                        },
                        tl: {
                          hd: {
                            label: "Is Business Order",
                            value: {
                              TAG: /* Text */0,
                              _0: services.is_pfe_order
                            }
                          },
                          tl: {
                            hd: {
                              label: "Is Otp Order",
                              value: {
                                TAG: /* Text */0,
                                _0: services.is_otp_order
                              }
                            },
                            tl: {
                              hd: {
                                label: "Is Order Editable",
                                value: {
                                  TAG: /* Text */0,
                                  _0: services.is_order_editable
                                }
                              },
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function NLOrderServicesInfo(Props) {
  var order = Props.order;
  var services = NLOrderServicesInfoVm.getVm(order);
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Order Services Information"
                    }, undefined, undefined, React.createElement(RecordsWrapper.make, {
                          children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(services))
                        }), undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrderServicesInfo;

export {
  getViewLabel ,
  make ,
  
}
/* react Not a pure module */
